import TransformationIf from '../../imports/transform/transformation-if'
import _ from 'lodash'
import Form from 'scoreboard/forms/model/form'
import dsaidSa from '../../../tests/scoreboard/datasets/dsaid-sexual-assaults'
import FormActionsEditor from 'scoreboard/forms/widgets/form-actions-editor'
import FormWidgetType from 'scoreboard/forms/model/form-widget-type'
const { BUTTON, FIELD } = FormWidgetType
import FormActionType from 'scoreboard/forms/model/form-action-type'
const { SAVE_RECORD, NEW_RECORD } = FormActionType
import Logician from 'scoreboard/components/logic/logician'
import StatementType from './model/statement-type'
const { AND_OR, OR_AND } = StatementType
import Dataset from 'scoreboard/datasets/model/dataset'

function logicianExample({ statements, formView, fieldId } = {}) {
	let widget = {
		id: 1,
		type: BUTTON,
		fieldId,
	}
	let form = new Form({
		widgets: [widget],
		dataset: dsaidSa
	})
	let dataset = new Dataset(dsaidSa)
	let treeItems = [ { id: 1, label: 'Total' } ]
	let treeItemsById = _.keyBy(treeItems, 'id')
	let logician = new Logician({
		formView,
		statements,
		conditionEditorCreator: condition => {
			return new TransformationIf({
				model: dataset,
				stronglyTyped: true,
				fields: dataset.get('fields'),
				formView,
				treeItemsById,
				transformation: {
					if: condition
				}
			})
		},
		consequencesEditorCreator: consequences => {
			return new FormActionsEditor({
				model: form,
				currentWidget: {
					id: 2,
					type: FIELD,
					fieldId: 2,
				},
				actions: consequences,
				formView
			})
		}
	})
	return logician
}


/** @type {ConditionalStatement} */
let statement1 = {
	statementType: AND_OR,
	conditions: [ {
		linkGroup: 0,
		fieldId: '7701', // alcohol involved
		operator: 'is-any',
		values: [ 'Yes' ]
	} ],
	consequences: [
		{ type: SAVE_RECORD },
		{ type: NEW_RECORD }
	]
}

/** @type {ConditionalStatement} */
let statement2 = {
	statementType: OR_AND,
	conditions: [ {
		linkGroup: 0,
		fieldId: '705', // Date of Incident
		operator: 'not-blank'
	}, {
		linkGroup: 1,
		fieldId: '702', // Victim Age
		operator: 'less-than',
		value1: 3
	} ],
	consequences: [
		{ type: SAVE_RECORD }
	]
}

/** @type {ConditionalStatement} */
let statement3 = {
	consequences: [
		{ type: NEW_RECORD }
	]
}

let rollupStatement = {
	statementType: OR_AND,
	conditions: [ {
		linkGroup: 0,
		fieldId: '1303', // Responsible SARC Location
		operator: 'is-any',
		rollupIsAnyFilters: { 1: 'item-rollups-and-descendants' }
	} ]
}

/** @type {ConditionalStatement[]} */
let twoStatements = [ statement1, statement3 ]

/** @type {ConditionalStatement[]} */
let threeStatements = [ statement1, statement2, statement3 ]

/** @type {ConditionalStatement[]} */
let rollupExample = [ rollupStatement, statement3 ]

export default logicianExample
export { statement1, statement2, statement3, twoStatements, threeStatements, rollupExample }

logicianExample.__filename__ = 'components/logic/logician-example.js'
